import arrayLikeToArray from "@babel/runtime/helpers/esm/arrayLikeToArray";
export default function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
// module id = 5070
// module chunks = 25